import { useState, useEffect } from "react";

/**
 * 첫 방문 모달 표시 로직.
 * URL 파라미터 firstVisit=true이고 localStorage에 출처 모달 표시 플래그가 있으면 500ms 후 바텀시트 표시.
 */
export function useFirstVisitModal(firstVisit: string | null) {
  const [showFirstVisitModal, setShowFirstVisitModal] = useState(false);

  useEffect(() => {
    const showSourceModal = localStorage.getItem("showSourceModal") === "true";
    const hasFirstVisitParam = firstVisit === "true";

    // URL 파라미터가 있고 localStorage에 출처 모달 표시 플래그가 있으면 0.5초 후 바텀시트
    if (hasFirstVisitParam && showSourceModal) {
      const timer = setTimeout(() => {
        setShowFirstVisitModal(true);
      }, 500);

      // 언마운트 시 타이머 정리
      return () => clearTimeout(timer);
    }
  }, [firstVisit]);

  const handleCloseFirstVisitModal = () => {
    setShowFirstVisitModal(false);
    // localStorage에서 출처 모달 표시 플래그 제거, URL에서 firstVisit 파라미터 제거
    localStorage.removeItem("showSourceModal");
    const url = new URL(window.location.href);
    url.searchParams.delete("firstVisit");
    window.history.replaceState({}, "", url.toString());
  };

  return { showFirstVisitModal, handleCloseFirstVisitModal };
}
